import { Box } from '@user-portal/wikr-components';
import styled, { keyframes } from 'styled-components';

const loaderPulseAnimation = keyframes`
    0% {
        transform: translate(-50%, -50%) scale(1);
    }

    50% {
        transform: translate(-50%, -50%) scale(1.4);
    }
    100% {
        transform: translate(-50%, -50%) scale(1);
    }
`;

export const Container = styled(Box)`
    ${({ theme, $backgroundColor }) => $backgroundColor && `background-color: ${theme[$backgroundColor]};`};
    width: 100vw;
    /* 100vh for older browsers, 100dvh for modern browsers with dynamic viewport handling */
    height: 100vh;
    height: 100dvh;
    display: flex;
    align-items: center;
    justify-content: center;

    > * {
        width: 40px;
        height: auto;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        animation: ${loaderPulseAnimation} 1s infinite;

        * {
            width: 100%;
        }
    }
`;
